export default {
  plans: [
    {
      name: '微型企業',
      price: '優惠價格請洽詢',
      count: 1,
      services: [
        '產品溯源履歷頁面',
        '平台設定'
      ],
      sticker: {
        count: '1000',
        price: 5
      }
    },
    {
      name: '小型企業',
      price: '優惠價格請洽詢',
      count: 2,
      services: [
        '產品溯源履歷頁面',
        '平台設定'
      ],
      sticker: {
        count: '1,001 ~ 3,000',
        price: 3.5
      }
    },
    {
      name: '大型企業',
      price: '優惠價格請洽詢',
      count: '3 - 5',
      services: [
        '產品溯源履歷頁面',
        '平台設定'
      ],
      sticker: {
        count: '5,001',
        price: 2
      }
    }
  ],
  plansWithIoTs: [
    {
      name: '微型企業',
      price: '優惠價格請洽詢',
      count: 1,
      services: [
        '產品溯源履歷頁面',
        '平台設定',
        '雲端IoT數據顯示平台',
        'IoT數據即時上鏈'
      ],
      sticker: {
        count: '1000',
        price: 5
      }
    },
    {
      name: '小型企業',
      price: '優惠價格請洽詢',
      count: 2,
      services: [
        '產品溯源履歷頁面',
        '平台設定',
        '雲端IoT數據顯示平台',
        'IoT數據即時上鏈'
      ],
      sticker: {
        count: '1,001 ~ 3,000',
        price: 3.5
      }
    },
    {
      name: '大型企業',
      price: '優惠價格請洽詢',
      count: '3 - 5',
      services: [
        '產品溯源履歷頁面',
        '平台設定',
        '雲端IoT數據顯示平台',
        'IoT數據即時上鏈'
      ],
      sticker: {
        count: '5,001',
        price: 2
      }
    }
  ],
  IoTs: [
    {
      name: '微氣象站',
      cover: require('@/assets/IOT01.jpg'),
      description: `最短須租1年，免費保固1年，租滿3年送裝置`
    },
    {
      name: '土壤檢測',
      cover: require('@/assets/IOT02.jpg'),
      description: `最短須租1年，免費保固1年，租滿3年送裝置`
    },
    {
      name: '閘道器與基地台',
      cover: require('@/assets/IOT03.jpg'),
      description: `最短須租1年，免費保固1年，租滿3年送裝置`
    }
  ]
}
